//import Moment from "moment";

const getCount = (state) => {
	return state.chamadosManutencao.length;
}

const ultimaAtualizacaoListaChamadoManutencao = (state) => {
	if (state.ultimaAtualizacaoListaChamadoManutencao == null) {
		return true;
	}
	else if(!state.chamadosManutencao)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.chamadosManutencao.length == 0 ||
			hour - state.ultimaAtualizacaoListaChamadoManutencao.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaChamadoManutencao
}